// Source
import * as HelperSrc from "../HelperSrc";
import * as ModelRole from "../model/Role";

export default class StoreRole {
    storageSet = (value: ModelRole.Idata): void => {
        HelperSrc.writeStorage<ModelRole.Idata>("role", value);

        HelperSrc.storageDispatchEvent("role");
    };

    storageGet = (): ModelRole.Idata | undefined => {
        return HelperSrc.readStorage<ModelRole.Idata>("role");
    };

    storageRemove = (): void => {
        HelperSrc.removeStorage("role");
    };
}
